var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
export var InvertableImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    return props.invert
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          transform: scaleX(-1);\n        "], ["\n          transform: scaleX(-1);\n        "]))) : '';
});
var templateObject_1, templateObject_2;
